<template>
    <v-layout>
      <v-flex>
      <v-card>
        <v-card-title>
          <h3>{{title}}</h3>
          <v-spacer></v-spacer>
          <v-checkbox 
              v-if="showAllEndpointsCheckbox"
              v-model="showUnassignedEndpoints" 
              @change="allEndpointsChanged"
              label="Show Unassigned Endpoints Only">
          </v-checkbox>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="fal fa-search"
            placeholder="Search"
            single-line
            hide-details
            clearable>
          </v-text-field>
        </v-card-title>
        <v-data-table
          :options.sync="pagination"
          :headers="headers"
          :items="endpoints"
          :search="search"
          :loading="myloading"
          v-model="selectionModel"
          :show-select="selection"
          @input="emit"
          class="elevation-1"
        >
          <template v-slot:item.id="{item}">
            <td v-if="showId">{{ item.id }}</td>
          </template>
          <template v-slot:item.aliases="{item}">
            <td>{{ getAliases(item.aliases) }}</td>
          </template>
          <template v-slot:item.hasCredentials="{item}">
            <td>
                {{ item.hasCredentials ? '&check;' : 'X' }}
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="error" type="warning">
              Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
      </v-flex>
    </v-layout>
</template>
<script>
import moment from 'moment'
import _ from 'lodash'

export default {
  props: {
    endpoints: Array,
    title: String,
    rowsPerPage: Number,
    loading: Boolean,
    selection: Boolean,
    showId: Boolean,
    reset: Boolean,
    showAllEndpointsCheckbox: Boolean
  },
  watch: {
    reset: function (updatedValue) {
      this.selectionModel = []
    }
  },
  updated() {
    // console.log('something got updated')
    // console.dir(arguments)
  },
  data() {
    return {
      myloading: this.loading,
      selectionModel: [],
      headers: [
          {text: 'Name', align: 'left', sortable: true, value: 'name'},
          {text: 'Host', align: 'left', sortable: true, value: 'hostAddress'},
          {text: 'Auth', align: 'left', sortable: true, value: 'hasCredentials'},
          {text: 'Aliases', align: 'left', sortable: true, value: 'aliases'},
          {text: 'DN', align: 'left', sortable: true, value: 'dn'},
          {text: 'Model', align: 'left', sortable: true, value: 'model'}
      ],
      pagination: {
        rowsPerPage: this.rowsPerPage
      },
      search: '',
      showUnassignedEndpoints: true
    }
  },
  created() {
    if (this.showId) {
      headers.unshift({text: 'Id', align: 'left', sortable: true, value: 'id'})
    }
  },
  methods: {
    getAliases(aliases) {
      if (!aliases) {
        return ''
      }
      let tokens = _.split(aliases, '/')
      return _.join(_.without(tokens, ''), ', ')
    },
    formatDateTime(val) {
      return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
    },
    emit(data) {
      this.$emit('selectionChanged', data)
    },
    allEndpointsChanged(data) {
      this.$emit('unassignedEndpointsChanged', data)
    }
  }
}
</script>
